import React from 'react';
import './Integrations.css';

function RevenueDocs() {
  return (
    <div className="integration-page">
      <div className="page-header">
        <h1>Revenue Authority Integration</h1>
        <p>Docs and example flows for submitting tax reports and invoices to Revenue Authority APIs.</p>
      </div>

      <div className="container">
        <section className="doc-section">
          <h2>Overview</h2>
          <p>
            We can integrate your systems with the local Revenue Authority to automate invoice submission, tax filings, and
            status checks. This improves compliance and reduces manual work.
          </p>
        </section>

        <section className="doc-section">
          <h2>Submit Filing (Example)</h2>
          <pre>
{`curl -X POST http://localhost:5000/api/integrations/revenue/submit \
  -H "Content-Type: application/json" \
  -d '{"companyTin":"P123456789","period":"2026-02","amount":10000}'`}
          </pre>
          <p>Response (simulated):</p>
          <pre>{`{
  "success": true,
  "submissionId": "RA-161234567890",
  "status": "submitted"
}`}</pre>
        </section>

        <section className="doc-section">
          <h2>Check Status</h2>
          <p>Use the status endpoint to poll for updates:</p>
          <pre>{`GET /api/integrations/revenue/status/:submissionId`}</pre>
        </section>

        <section className="doc-section">
          <h2>Environment Variables</h2>
          <ul>
            <li><code>RA_API_KEY</code></li>
            <li><code>RA_API_SECRET</code></li>
            <li><code>RA_BASE_URL</code></li>
          </ul>
        </section>
      </div>
    </div>
  );
}

export default RevenueDocs;
